import { Button, Flex, Form, Image, Input, Modal, Space } from 'antd';
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import './App.css';
import { useForm } from 'antd/es/form/Form';
import axios from 'axios';
import { useState } from 'react';
import Confetti from "react-confetti";

function App() {
  const [form] = useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const [kq, setKq] = useState<any[] | undefined>(undefined);
  const [showConfetti, setShowConfetti] = useState(false);

  const onSubmit = async(val: any) => {
    try {
      setLoading(true);
      const res = await axios.get("https://xettuyen.hvpnvn.edu.vn/api/ket-qua-xet-tuyen-public/2024", {
        params: val
      });
      const kqXetTuyen = res.data.data;
      if(kqXetTuyen) {
        setKq(kqXetTuyen);
        if(kqXetTuyen.length > 0) {
          setShowConfetti(true);
          setTimeout(() => setShowConfetti(false), 5000); 
        }
      }
    } catch(err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }
  return (
    <div className="App">
      <Form form={form} onFinish={onSubmit}>
        <Flex gap="10px" justify='center' align='center' style={{marginBottom: '40px'}}>
          <Image src='/logo-vwa.png' preview={false} width={'80px'}/>
          <h2>Tra cứu kết quả tuyển sinh theo CMND/CCCD</h2>
        </Flex>
        <Space className="traCuu" direction='vertical'>
          <Form.Item name="cmtCccd" rules={[{ required: true, message: "Vui lòng nhập CMND/CCCD" }]}>
            <Input placeholder='Nhập CMND/CCCD'/>
          </Form.Item>
          
          <Flex gap="10px" justify='center'>
            <Button type='primary' loading={loading} icon={<SearchOutlined />} htmlType='submit'>
              Tra cứu
            </Button>
            <Button type='primary' ghost icon={<ReloadOutlined />} onClick={() => form.resetFields()}>
              Làm lại
            </Button>
          </Flex>
        </Space>
      </Form>
      {showConfetti && <Confetti />}
      <Modal width={800} title={`${kq?.length === 0? "Học viện Phụ nữ Việt Nam thông báo": "Học viện Phụ nữ Việt Nam chúc mừng"}`} 
      open={Boolean(kq)} 
      onCancel={() => setKq(undefined)}
      okText="Đóng"
      onOk={() => setKq(undefined)} cancelButtonProps={{ style: { display: "none" } }}>
        {
          kq?.length === 0 ? 
          <div style={{fontSize: '16px'}}>
            <p>Học viện Phụ nữ Việt Nam rất tiếc thông báo: bạn không đủ điều kiện trúng tuyển xét tuyển sớm đại học chính quy Đợt 2 năm 2024 Học viện. Điểm chuẩn xét tuyển sớm Đợt 2 năm 2024 của Học viện Phụ nữ Việt Nam tra cứu như sau: <a href='https://xettuyen.hvpnvn.edu.vn/api/file/668753fde4c1e942b5286a06/tb%20kq%20xts%20dot%202.2024.pdf'>Thông báo điểm trúng tuyển đợt 2</a>
            </p><p>Trong trường hợp bạn cho rằng điểm của mình cao hơn các điểm trúng tuyển vào ngành mà mình đã đăng ký thì bạn có thể liên hệ với Bộ phận Tuyển sinh của Học viện để kiểm tra.
            </p><p>Nếu bạn mong muốn tiếp tục được xét tuyển vào Học viện Phụ nữ Việt Nam, đề nghị bạn thường xuyên cập nhật các thông báo mới nhất trên Website của Học viện
            </p><p>Trân trọng!</p>
            <div style={{lineHeight: '24px'}} className='section'>
              <p>Học viện Phụ nữ Việt Nam,
              </p><p>Thông tin hỗ trợ tuyển sinh:
              </p><p>Website: <a href='https://tuyensinh.hvpnvn.edu.vn/'>https://tuyensinh.hvpnvn.edu.vn/</a>; Email: <a href='mailTo:tuyensinh@hvpnvn.edu.vn'>tuyensinh@hvpnvn.edu.vn</a>;
              </p><p>Fanpage: <a href='https://www.facebook.com/TUYENSINHHOCVIENPHUNUVN'>https://www.facebook.com/TUYENSINHHOCVIENPHUNUVN</a>
              </p><p>Điện thoại: 0243.7751750; 0912.347.895; 0912.991.355.</p>
            </div>
          </div> :
          <>
            {
              kq?.map(item => <div style={{fontSize: '16px', marginTop: '20px'}}>
                <div style={{lineHeight: '24px'}} className='section'>
                <p>Thí sinh: <strong>{item.hoTen}</strong>
                </p><p>Mã hồ sơ: <strong>{item.maHoSo}</strong>
                </p><p>Ngày sinh: <strong>{item.ngaySinh}</strong>
                </p><p>CMND/CCCD: <strong>{item.cmtCccd}</strong>
                </p>
                </div>
                <div style={{lineHeight: '24px'}} className='section'>
                <p>Đã đủ điều kiện trúng tuyển (trừ điều kiện tốt nghiệp THPT) đại học chính quy xét tuyển sớm Đợt 2 năm 2024 của Học viện, cụ thể như sau:
                </p><p>Ngành: <strong>{item.nganh}</strong>
                </p><p>Mã ngành: <strong>{item.maNganh}</strong>
                </p><p>Cơ sở đào tạo: <strong>{item.coSoDaoTao}</strong>
                </p><p>Thứ tự nguyện vọng: <strong>{item.thuTuNguyenVong}</strong>
                </p><p>Phương thức: <strong>{item.phuongThuc}</strong>
                </p>
                </div>
                <div style={{lineHeight: '24px'}} className='section'>
                <p>Bạn cần đăng ký (trực tuyến) nguyện vọng (NV) trên Hệ thống/Cổng thông tin tuyển sinh của Bộ Giáo dục và Đào tạo (Bộ GD&ĐT). Bạn phải xác nhận số lượng, thứ tự NV và thực hiện các hướng dẫn theo quy định trên Hệ thống của Bộ GD&ĐT. Nếu bạn không đăng ký NV trúng tuyển này lên hệ thống của Bộ GD&ĐT thì coi như từ chối NV trúng tuyển vào Học viện
                </p><p>Hãy trở thành sinh viên chính thức của Học viện Phụ nữ Việt Nam bằng cách đăng ký vào Học viện bằng NV1 trên hệ thống của Bộ GD&ĐT.
                </p>
                </div><p>Trân trọng!</p>
                <div style={{lineHeight: '24px'}} className='section'>
                  <p>Mọi thắc mắc xin liên hệ:
                  </p><p>Trụ sở chính Học viện Phụ nữ Việt Nam: 68 Nguyễn Chí Thanh, Đống Đa, Hà Nội.
                  </p><p>Website: <a href='https://tuyensinh.hvpnvn.edu.vn/'>https://tuyensinh.hvpnvn.edu.vn/</a>; Email: <a href='mailTo:tuyensinh@hvpnvn.edu.vn'>tuyensinh@hvpnvn.edu.vn</a>;
                  </p><p>Fanpage: <a href='https://www.facebook.com/TUYENSINHHOCVIENPHUNUVN'>https://www.facebook.com/TUYENSINHHOCVIENPHUNUVN</a>
                  </p><p>Điện thoại: 0243.7751750; 0912.347.895; 0912.991.355.</p>
                </div>
              </div>)
            }
          </>
        }
      </Modal>
    </div>
  );
}

export default App;
